<template>
  <!--api模板-->
  <el-container class="contract">
    <el-main class="main">
      <el-table
        :data="tplList"
        tooltip-effect="dark"
        class="tpl-table data-list"
        style="height: calc(100vh - 262px)"
        v-loading="loading"
        :header-cell-style="{
          background: '#f9f9f9',
          color: '#333333',
          fontWeight: '500',
        }"
      >
        <el-table-column
          label="模板ID"
          prop="serialNum"
          width="100"
          show-overflow-tooltip
        />
        <el-table-column label="名称" prop="tplName" show-overflow-tooltip />
        <el-table-column label="创建时间" prop="createTime">
          <template slot-scope="scope">{{
            scope.row.createTime | formatDateTime
          }}</template>
        </el-table-column>
        <el-table-column label="更新时间" prop="updateTime">
          <template slot-scope="scope">{{
            scope.row.updateTime | formatDateTime
          }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <p slot-scope="scope" class="action pointer">
            <span
              @click="
                $router.push({
                  path: '/tpl/add/api',
                  query: { tplId: scope.row.tplId },
                })
              "
              class="color-success"
              >修改</span
            >
            <span @click="delTpl(scope.row)" class="color-danger">删除</span>
          </p>
        </el-table-column>
      </el-table>

      <el-row class="pageation row">
        <el-col :span="4">
          <el-button
            @click="
              $router.push({
                path: '/tpl/add/api',
                query: { tplGroupTypeId: operGroupType.tplGroupTypeId },
              })
            "
            size="small"
            >新增模板</el-button
          >
        </el-col>
        <el-col :span="20" class="page-flex-end">
          <el-pagination
            v-if="paged.total > 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :total="paged.total"
            :current-page.sync="paged.pageNum"
            :page-size="paged.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="sizes, prev, pager, next, total"
          />
          <el-go
            :page-size="paged.pageSize"
            :total="paged.total"
            @current-change="handleCurrentChange"
          ></el-go>
        </el-col>
      </el-row>

      <el-dialog
        :visible.sync="dialogFormVisible"
        title="请输入模板名称"
        :close-on-click-modal="false"
        width="260px"
      >
        <el-input
          v-model="operGroupType.tplGroupTypeName"
          size="small"
          :maxlength="50"
        />
        <div slot="footer" class="dialog-footer">
          <el-button @click="saveOrUpdateGroupType()" size="small" type="danger"
            >确定</el-button
          >
          <el-button @click="dialogFormVisible = false" size="small"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import { ApiMethods } from "../../assets/js/http-serve/http-methods";
import ElGo from '../../components/go/Go'
export default {
  components: { ElGo },
  methods: {
    showOperGroupType: function (idx) {
      if (idx !== undefined) {
        this.operGroupType = JSON.parse(JSON.stringify(this.groupList[idx]));
      } else {
        this.operGroupType = {}
      }
      this.dialogFormVisible = true;
    },
    saveOrUpdateGroupType: function () {
      if (!this.operGroupType.tplGroupTypeName) return this.$message.error('请输入模板名称')
      if (this.operGroupType.tplGroupTypeName.length > 10) return this.$message.error('模板名称不能超过10个字符')
      var _this = this;
      var param = _this.operGroupType;
      ApiMethods.ApiTemplateController.operTplGroupType(param).then(result => {
        if (result.success) {
          _this.queryGroupTypeList();
          _this.dialogFormVisible = false
        } else {
          _this.$message.error(result.description || this.$tip)
        }
      })
    },
    queryGroupTypeTpl: function (item) {
      var _this = this;
      if (_this.operGroupType.tplGroupTypeId != item.tplGroupTypeId) {//已经是当前group不处理
        _this.operGroupType = item;
        _this.queryList();
      }
    },
    delGroupTypeTpl: function () {
      var _this = this;
      _this.$confirm('确认删除分类?', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          var param = { tplGroupTypeId: _this.operGroupType.tplGroupTypeId };
          ApiMethods.ApiTemplateController.delTplGroupType(param).then(result => {
            if (result.success) {
              _this.$alert('操作成功', '系统提示', {
                confirmButtonText: '确定', callback: action => {
                  _this.queryGroupTypeList();
                }
              });
            } else {
              _this.$alert(result.description || '操作失败,该分类下存在数据', '系统提示')
              console.error("==info[20180720/115027.198]==" + result.description);
            }
          });
        }).catch(() => {
          _this.$message({ type: 'info', message: '已取消操作' });
        });
    },

    delTpl: function (target) {
      var _this = this;
      _this.$confirm('此操作将永久删除该模板, 是否继续?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var param = { tplId: target.tplId };
        ApiMethods.ApiTemplateController.delTpl(param).then(result => {
          if (result.success) {
            _this.$alert('操作成功', '系统提示', { confirmButtonText: '确定', callback: action => { _this.queryList(); } });
          } else {
            _this.$alert(result.description || '操作失败', '系统提示')
          }
        });
      }).catch(() => {
      });
    },
    handleCurrentChange: function (val) {
      this.paged.pageNum = val;
      this.queryList();
    },
    handleSizeChange: function (val) {
      this.paged.pageSize = val;
      this.queryList();
    },
    queryList: function () {
      let param = { itemPage: this.paged.pageNum, pageSize: this.paged.pageSize, tplGroupTypeId: this.operGroupType.tplGroupTypeId };
      this.loading = true;
      ApiMethods.ApiTemplateController.listTpl(param).then(result => {
        if (result.success) {
          this.tplList = result.data;
          this.paged = { pageNum: result.pageNum, pageSize: result.pageSize, pages: result.pages, total: result.total };
        } else {
          this.$message.error(result.description || this.$tip)
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    queryGroupTypeList: function () {
      var _this = this;
      ApiMethods.ApiTemplateController.tplGroupType({}).then(result => {
        if (result.success) {
          _this.groupList = result.data;
        } else {
          _this.$message.error(result.description || this.$tip)
        }
      });
    }
  },
  watch: {
    '$route.query': {
      handler (val) {
        this.operGroupType.tplGroupTypeId = val.tplTypeId
        this.queryList()
      },
      deep: true
    }
  },
  created () {
    this.operGroupType.tplGroupTypeId = this.$route.query.tplTypeId
    this.queryList();
  },
  data () {
    return {
      paged: { itemPage: 1, pageSize: 10, },
      tplGroupTypeId: "",
      groupList: [],
      tplList: [],
      operGroupType: {},
      currentData: { groupId: 0, data: null },
      dialogFormVisible: false,
      currentPage: 1,
      loading: false
    }
  },
  name: "contract"
}
</script>

<style lang="less" scoped>
.group-icon {
  float: right;
  margin-right: 10px;
  font-size: 14px;
}
.contract {
  max-width: 1200px;
  margin: 0 auto;
  min-height: 0;
  .tpl-table {
    width: 100%;
    border: 1px solid #efefef;
    border-bottom: 0;

    .action span {
      display: inline-block;
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .pageation {
    padding: 30px 10px 20px 10px;
    border-top: 0;
    min-height: 85px;
  }

  .add-group {
    text-align: center;
    line-height: 300%;
    border-bottom: 1px solid #efefef;
    color: #666666;
    cursor: pointer;
  }
  .add-group:hover {
    background: #ec1c1c;
    color: #ffffff;
  }

  .main {
    box-sizing: border-box;
    display: table-cell;
    vertical-align: top;
  }

  .aside {
    width: 200px;
    box-sizing: border-box;
    margin-right: 10px;
    border: 1px solid #efefef;
    min-height: 400px;

    .group-list {
      li {
        clear: both;
        cursor: pointer;
        margin: 15px 0;
        list-style: none;
        border-top: 1px dashed transparent;
        border-right: 1px dashed transparent;
        border-bottom: 1px dashed transparent;
        border-left: 2px solid transparent;
        line-height: 240%;
        padding-left: 10px;
        color: #999999;
        overflow: hidden;

        p {
          display: none;
          float: right;
          width: 50px;
        }
        &:hover {
          p {
            display: block;
          }
        }
        p.name {
          display: block;
          float: left;
          width: calc(100% - 50px);
        }
      }
      li:hover,
      li.active {
        border-color: #efefef;
        border-left-color: #ec1c1c;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/tpl/api.vue